// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import { ParameterDO } from '../../requests';

interface Props {
  formValues: {
    data: Partial<ParameterDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.name"
            name="data.name"
            value={_.defaultTo(data.name, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Name"
            required
            readOnly
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Description</b> &nbsp;
          </label>
          <textarea
            id="data.description"
            name="data.description"
            value={_.defaultTo(data.description, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Description"
            required
            readOnly
            rows={5}
            cols={40}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Value</b> &nbsp;
          </label>
          <textarea
            id="data.value"
            name="data.value"
            value={_.defaultTo(data.value, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Value"
            required
            rows={5}
            cols={40}
          />
        </div>
      </div>
    </fieldset>
  );
}
